@if (dataPointsForChart$ | async) {
  <app-chart-tile
    [title]="'mixit-thermal-power-chart.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
